import { unstable_cache } from 'next/cache';

import { Tenant } from '@core/Entities/App/Tenants.entity';
import { Locale } from '@core/Entities/Locale/Locale.entity';
import { DEFAULT_REVALIDATE } from '@core/Utils/App/DefaultRevalidate';
import { getNiceKenticoContent } from '@kentico/GetNiceKenticoContent';
import { removeInternalProps } from '@kentico/Utils/RemoveInternalProps';

import { CampaignBanner, HeroCampaignBanner } from '../Entities/CampaignBanner.entity';

export const fetchHeroCampaignBanner = unstable_cache(
  async (locale: Locale, tenant?: Tenant) =>
    getNiceKenticoContent<HeroCampaignBanner>('active_hero_campaign_banner', 4, locale, tenant),
  ['active-hero-campaign-banner'],
  { revalidate: DEFAULT_REVALIDATE },
);

export const shouldShowCampaignBanner = (
  activeHeroCampaignBanner: HeroCampaignBanner,
  page: string,
) =>
  activeHeroCampaignBanner?.campaign?.[0] &&
  activeHeroCampaignBanner?.pages.find(({ codename }: { codename: string }) => codename === page);

export const getCorrectBanner = (
  activeHeroCampaignBanner: HeroCampaignBanner,
  isEcom?: boolean,
  isD2c?: boolean,
) => {
  const { eComInvestorStockPageBanner, eComPageBanner, investorStockPageBanner, campaign } =
    activeHeroCampaignBanner;

  if (isEcom && isD2c && eComInvestorStockPageBanner?.[0])
    return removeInternalProps<CampaignBanner>(eComInvestorStockPageBanner?.[0]);
  if (isEcom && eComPageBanner?.[0])
    return removeInternalProps<CampaignBanner>(eComPageBanner?.[0]);
  if (isD2c && investorStockPageBanner?.[0])
    return removeInternalProps<CampaignBanner>(investorStockPageBanner?.[0]);
  return removeInternalProps<CampaignBanner>(campaign?.[0]);
};
